import { render, staticRenderFns } from "./UtdSearchBar.vue?vue&type=template&id=0d537104&scoped=true"
import script from "./UtdSearchBar.vue?vue&type=script&lang=js"
export * from "./UtdSearchBar.vue?vue&type=script&lang=js"
import style0 from "./UtdSearchBar.vue?vue&type=style&index=0&id=0d537104&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d537104",
  null
  
)

export default component.exports